export default __webpack_public_path__ + "images/fetal_sex_blue.0e203361388fd63befb59ececf2897d1.png";